import { useEffect, useState } from 'react'

interface ExtensionDetectionConfig {
	assumeInstalled?: boolean
}

export function useExtensionDetection(config?: ExtensionDetectionConfig) {
	const [isExtensionInstalled, setIsExtensionInstalled] = useState(
		config?.assumeInstalled ?? false,
	)

	useEffect(() => {
		let timeout: NodeJS.Timeout
		let messageListener: (event: MessageEvent) => void

		const checkExtension = () => {
			// Set up message listener for response
			messageListener = (event: MessageEvent) => {
				if (
					event.data?.type === 'EXTENSION_PONG' &&
					event.data?.data?.installed
				) {
					setIsExtensionInstalled(true)
					clearTimeout(timeout)
					window.removeEventListener('message', messageListener)
				}
			}

			window.addEventListener('message', messageListener)

			// Send ping to extension
			const pingMessage = {
				type: 'EXTENSION_PING',
				timestamp: Date.now(),
			}

			window.postMessage(pingMessage, window.location.origin)

			// If no response after a short delay, set to not installed
			timeout = setTimeout(() => {
				setIsExtensionInstalled(false)
				window.removeEventListener('message', messageListener)
			}, 100) // Quick check
		}

		// Check immediately
		checkExtension()

		// Cleanup function
		return () => {
			clearTimeout(timeout)
			if (messageListener) {
				window.removeEventListener('message', messageListener)
			}
		}
	}, [])

	return {
		isExtensionInstalled,
	}
}
